const lightColors = {
  primaryColor: "#440099",
  secondaryColor: "#7D55C7",
  dark: "#1D232F",
  gray: "#A4ABB8",
  light: "#C0C6CF",
  feintGray: "#777E8B",
  feintWhite: "#C2DFF5",
  neutralContent: "#718096",
  disabled: "#E9E9EC",
  midGray: "#4E5461",
  lightGray: "#F6F8FA",
  offGray: "#F4F4F4",
  errorContent: "#ff0000",
  backgroundGray: "#EAEDF2",
  softGray: "#DBDFE7",
  sematicRed: "#E22B3D",
  sematicGreen: "#06BF7F",
  sematicYellow: "#FCC838",
  sematicFaintYellow: "rgba(252, 200, 56, 0.4)",
  darkGray: "#363434",
  cyan: "#74d1ea",
  blueishGray: "#EAEFF4",
  whiteBackdrop: "#FFFFFF99",
  pureWhite: "#FFFFFF",
  pureBlack: "#000000",
  measureColor: "#E0F8EF",
  measureColorHover: "#C7F2E3",
  attributeColor: "#DEE8FA",
  attributeColorHover: "#CEDCF5",
  otherColor: "#B196E3",
  dateColor: "#F0EBFF",
  dateColorHover: "#E3D9FC",
  unrecognizedColor: "#FCD4D7",
  unrecognizedColorHover: "#FEE4E6",
};

const darkColors = {
  primaryColor: "#7D55C7",
  secondaryColor: "#440099",
  dark: "#DEE1E3",
  gray: "#64748B",
  light: "#334155",
  feintGray: "#94A3B8",
  feintWhite: "#1E293B",
  neutralContent: "#CBD5E1",
  disabled: "#475569",
  midGray: "#E2E8F0",
  lightGray: "#0F172A",
  offGray: "#1E293B",
  errorContent: "#EF4444",
  backgroundGray: "#777E8B",
  softGray: "#475569",
  sematicRed: "#F87171",
  sematicGreen: "#34D399",
  sematicYellow: "#FBBF24",
  sematicFaintYellow: "rgba(251, 191, 36, 0.4)",
  darkGray: "#F8FAFC",
  cyan: "#67E8F9",
  blueishGray: "#1E293B",
  whiteBackdrop: "#00000099",
  pureWhite: "#1E293B",
  pureBlack: "#777E8B",
  measureColor: "#37694E",
  measureColorHover: "#5F9176",
  attributeColor: "#2F4F84",
  attributeColorHover: "#578AE5",
  otherColor: "#B196E3",
  dateColor: "#6C4E86",
  dateColorHover: "#8D66EE",
  unrecognizedColor: "#AF5A60",
  unrecognizedColorHover: "#A66B6F",
};

export const colors = lightColors;

export type ColorScheme = typeof lightColors;

export const themes = {
  light: lightColors,
  dark: darkColors,
} as const;

export type ThemeMode = keyof typeof themes;
